'use strict';

function anchorsFunction(g) {
  function init() {
    var hash = window.location.hash;

    if (hash) {
      if ($(hash).length === 0) {
        return;
      }

      var positionSection = $(hash).closest('.accordion').offset().top - 30; // décalage de 20px pour laisser de la place entre le header et la section
      var hauteurHeader = g.$navMain.outerHeight();
      var scrollValue = positionSection - hauteurHeader;

      // Place le scroll au niveau de la section mentionnée dans le # de l'URL
      $('html, body').animate({scrollTop: scrollValue}, 500, function() {});
    }
  }

  init();
}
